export enum ProductAccessStatus {
	Default = 0,
	Allowed = 1,
	Denied = 2,
}

export const productAccessStatusNames = {
	[ProductAccessStatus.Default]: 'Not registered',
	[ProductAccessStatus.Allowed]: 'Allowed',
	[ProductAccessStatus.Denied]: 'Denied',
};

export const getProductAccessStatusName = (status: ProductAccessStatus) =>
	productAccessStatusNames[status];
